import angular from 'angular';
import JackpotsNextDrawsWidgetComponent from './jackpots-next-draws-widget-component';

export default angular
  .module('jackpots-next-draws-widget', [])
  .component('jackpotsNextDrawsWidget', new JackpotsNextDrawsWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/jackpots-next-draws/jackpots-next-draws-widget-module.js